export const HOT_CITIES = [
  '北京',
  '上海',
  '广州',
  '杭州',
  '深圳',
  '成都',
  '重庆',
  '大连',
  '南京',
  '天津',
  '西安',
  '苏州',
  '武汉',
  '厦门',
  '长沙',
  '郑州',
  '佛山',
  '合肥',
  '济南',
  '青岛',
  '昆明',
  '南昌',
  '东莞',
  '宁波',
];

type CityPinyinList = {
  letter: string;
  city: { pinyin: string; name: string }[];
}[];

export const CITIES_PINYIN_LIST: CityPinyinList = [
  {
    letter: 'a',
    city: [
      { pinyin: 'abazangzuqiangzuzizhizhou', name: '阿坝藏族羌族自治州' },
      { pinyin: 'akesudiqu', name: '阿克苏地区' },
      { pinyin: 'alaer', name: '阿拉尔' },
      { pinyin: 'alashanmeng', name: '阿拉善盟' },
      { pinyin: 'aleitaidiqu', name: '阿勒泰地区' },
      { pinyin: 'alidiqu', name: '阿里地区' },
      { pinyin: 'ankang', name: '安康' },
      { pinyin: 'anqing', name: '安庆' },
      { pinyin: 'anshan', name: '鞍山' },
      { pinyin: 'anshun', name: '安顺' },
      { pinyin: 'anyang', name: '安阳' },
      { pinyin: 'aomenbandao', name: '澳门半岛' },
    ],
  },
  {
    letter: 'b',
    city: [
      { pinyin: 'baicheng', name: '白城' },
      { pinyin: 'baise', name: '百色' },
      { pinyin: 'baishalizuzizhixian', name: '白沙黎族自治县' },
      { pinyin: 'baishan', name: '白山' },
      { pinyin: 'baiyin', name: '白银' },
      { pinyin: 'baoding', name: '保定' },
      { pinyin: 'baoji', name: '宝鸡' },
      { pinyin: 'baoshan', name: '保山' },
      { pinyin: 'baotinglizumiaozuzizhixian', name: '保亭黎族苗族自治县' },
      { pinyin: 'baotou', name: '包头' },
      { pinyin: 'bayannaoer', name: '巴彦淖尔' },
      { pinyin: 'bayinguolengmengguzizhizhou', name: '巴音郭楞蒙古自治州' },
      { pinyin: 'bazhong', name: '巴中' },
      { pinyin: 'beihai', name: '北海' },
      { pinyin: 'beijing', name: '北京' },
      { pinyin: 'beitun', name: '北屯' },
      { pinyin: 'bengbu', name: '蚌埠' },
      { pinyin: 'benxi', name: '本溪' },
      { pinyin: 'bijie', name: '毕节' },
      { pinyin: 'binzhou', name: '滨州' },
      { pinyin: 'boertalamengguzizhizhou', name: '博尔塔拉蒙古自治州' },
      { pinyin: 'bozhou', name: '亳州' },
    ],
  },
  {
    letter: 'c',
    city: [
      { pinyin: 'cangzhou', name: '沧州' },
      { pinyin: 'changchun', name: '长春' },
      { pinyin: 'changde', name: '常德' },
      { pinyin: 'changdu', name: '昌都' },
      { pinyin: 'changjianglizuzizhixian', name: '昌江黎族自治县' },
      { pinyin: 'changjihuizuzizhizhou', name: '昌吉回族自治州' },
      { pinyin: 'changsha', name: '长沙' },
      { pinyin: 'changzhi', name: '长治' },
      { pinyin: 'changzhou', name: '常州' },
      { pinyin: 'chaoyang', name: '朝阳' },
      { pinyin: 'chaozhou', name: '潮州' },
      { pinyin: 'chengde', name: '承德' },
      { pinyin: 'chengdu', name: '成都' },
      { pinyin: 'chengmaixian', name: '澄迈县' },
      { pinyin: 'chenzhou', name: '郴州' },
      { pinyin: 'chifeng', name: '赤峰' },
      { pinyin: 'chizhou', name: '池州' },
      { pinyin: 'chongqing', name: '重庆' },
      { pinyin: 'chongzuo', name: '崇左' },
      { pinyin: 'chuxiongyizuzizhizhou', name: '楚雄彝族自治州' },
      { pinyin: 'chuzhou', name: '滁州' },
    ],
  },
  {
    letter: 'd',
    city: [
      { pinyin: 'dalian', name: '大连' },
      { pinyin: 'dalibaizuzizhizhou', name: '大理白族自治州' },
      { pinyin: 'dandong', name: '丹东' },
      { pinyin: 'dangzaidao', name: '氹仔岛' },
      { pinyin: 'danzhou', name: '儋州' },
      { pinyin: 'daqing', name: '大庆' },
      { pinyin: 'datong', name: '大同' },
      { pinyin: 'daxinganlingdiqu', name: '大兴安岭地区' },
      { pinyin: 'dazhou', name: '达州' },
      { pinyin: 'dehongdaizujingpozuzizhizhou', name: '德宏傣族景颇族自治州' },
      { pinyin: 'deyang', name: '德阳' },
      { pinyin: 'dezhou', name: '德州' },
      { pinyin: 'dinganxian', name: '定安县' },
      { pinyin: 'dingxi', name: '定西' },
      { pinyin: 'diqingzangzuzizhizhou', name: '迪庆藏族自治州' },
      { pinyin: 'dongfang', name: '东方' },
      { pinyin: 'dongguan', name: '东莞' },
      { pinyin: 'dongying', name: '东营' },
    ],
  },
  {
    letter: 'e',
    city: [
      { pinyin: 'eerduosi', name: '鄂尔多斯' },
      { pinyin: 'enshitujiazumiaozuzizhizhou', name: '恩施土家族苗族自治州' },
      { pinyin: 'ezhou', name: '鄂州' },
    ],
  },
  {
    letter: 'f',
    city: [
      { pinyin: 'fangchenggang', name: '防城港' },
      { pinyin: 'foshan', name: '佛山' },
      { pinyin: 'fushun', name: '抚顺' },
      { pinyin: 'fuxin', name: '阜新' },
      { pinyin: 'fuyang', name: '阜阳' },
      { pinyin: 'fuzhou', name: '抚州' },
      { pinyin: 'fuzhou', name: '福州' },
    ],
  },
  {
    letter: 'g',
    city: [
      { pinyin: 'gannanzangzuzizhizhou', name: '甘南藏族自治州' },
      { pinyin: 'ganzhou', name: '赣州' },
      { pinyin: 'ganzizangzuzizhizhou', name: '甘孜藏族自治州' },
      { pinyin: 'gaoxiong', name: '高雄' },
      { pinyin: 'guangan', name: '广安' },
      { pinyin: 'guangyuan', name: '广元' },
      { pinyin: 'guangzhou', name: '广州' },
      { pinyin: 'guigang', name: '贵港' },
      { pinyin: 'guilin', name: '桂林' },
      { pinyin: 'guiyang', name: '贵阳' },
      { pinyin: 'guoluozangzuzizhizhou', name: '果洛藏族自治州' },
      { pinyin: 'guyuan', name: '固原' },
    ],
  },
  {
    letter: 'h',
    city: [
      { pinyin: 'haerbin', name: '哈尔滨' },
      { pinyin: 'haibeizangzuzizhizhou', name: '海北藏族自治州' },
      { pinyin: 'haidong', name: '海东' },
      { pinyin: 'haikou', name: '海口' },
      { pinyin: 'hainanzangzuzizhizhou', name: '海南藏族自治州' },
      { pinyin: 'haiximengguzuzangzuzizhizhou', name: '海西蒙古族藏族自治州' },
      { pinyin: 'hamidiqu', name: '哈密地区' },
      { pinyin: 'handan', name: '邯郸' },
      { pinyin: 'hangzhou', name: '杭州' },
      { pinyin: 'hanzhong', name: '汉中' },
      { pinyin: 'hebi', name: '鹤壁' },
      { pinyin: 'hechi', name: '河池' },
      { pinyin: 'hefei', name: '合肥' },
      { pinyin: 'hegang', name: '鹤岗' },
      { pinyin: 'heihe', name: '黑河' },
      { pinyin: 'hengshui', name: '衡水' },
      { pinyin: 'hengyang', name: '衡阳' },
      { pinyin: 'hetiandiqu', name: '和田地区' },
      { pinyin: 'heyuan', name: '河源' },
      { pinyin: 'heze', name: '菏泽' },
      { pinyin: 'hezhou', name: '贺州' },
      { pinyin: 'honghehanizuyizuzizhizhou', name: '红河哈尼族彝族自治州' },
      { pinyin: 'huaian', name: '淮安' },
      { pinyin: 'huaibei', name: '淮北' },
      { pinyin: 'huaihua', name: '怀化' },
      { pinyin: 'huainan', name: '淮南' },
      { pinyin: 'hualianxian', name: '花莲县' },
      { pinyin: 'huanggang', name: '黄冈' },
      { pinyin: 'huangnanzangzuzizhizhou', name: '黄南藏族自治州' },
      { pinyin: 'huangshan', name: '黄山' },
      { pinyin: 'huangshi', name: '黄石' },
      { pinyin: 'huhehaote', name: '呼和浩特' },
      { pinyin: 'huizhou', name: '惠州' },
      { pinyin: 'huludao', name: '葫芦岛' },
      { pinyin: 'hulunbeier', name: '呼伦贝尔' },
      { pinyin: 'huzhou', name: '湖州' },
    ],
  },
  {
    letter: 'j',
    city: [
      { pinyin: 'jiamusi', name: '佳木斯' },
      { pinyin: 'jian', name: '吉安' },
      { pinyin: 'jiangmen', name: '江门' },
      { pinyin: 'jiaozuo', name: '焦作' },
      { pinyin: 'jiaxing', name: '嘉兴' },
      { pinyin: 'jiayi', name: '嘉义' },
      { pinyin: 'jiayixian', name: '嘉义县' },
      { pinyin: 'jiayuguan', name: '嘉峪关' },
      { pinyin: 'jieyang', name: '揭阳' },
      { pinyin: 'jilin', name: '吉林' },
      { pinyin: 'jilong', name: '基隆' },
      { pinyin: 'jinan', name: '济南' },
      { pinyin: 'jinchang', name: '金昌' },
      { pinyin: 'jincheng', name: '晋城' },
      { pinyin: 'jingdezhen', name: '景德镇' },
      { pinyin: 'jingmen', name: '荆门' },
      { pinyin: 'jingzhou', name: '荆州' },
      { pinyin: 'jinhua', name: '金华' },
      { pinyin: 'jining', name: '济宁' },
      { pinyin: 'jinmenxian', name: '金门县' },
      { pinyin: 'jinpuxinqu', name: '金普新区' },
      { pinyin: 'jinzhong', name: '晋中' },
      { pinyin: 'jinzhou', name: '锦州' },
      { pinyin: 'jiujiang', name: '九江' },
      { pinyin: 'jiulong', name: '九龙' },
      { pinyin: 'jiuquan', name: '酒泉' },
      { pinyin: 'jixi', name: '鸡西' },
      { pinyin: 'jiyuan', name: '济源' },
    ],
  },
  {
    letter: 'k',
    city: [
      { pinyin: 'kaifeng', name: '开封' },
      { pinyin: 'kashidiqu', name: '喀什地区' },
      { pinyin: 'kelamayi', name: '克拉玛依' },
      { pinyin: 'kezileisukeerkezizizhizhou', name: '克孜勒苏柯尔克孜自治州' },
      { pinyin: 'kunming', name: '昆明' },
    ],
  },
  {
    letter: 'l',
    city: [
      { pinyin: 'laibin', name: '来宾' },
      { pinyin: 'laiwu', name: '莱芜' },
      { pinyin: 'langfang', name: '廊坊' },
      { pinyin: 'lanzhou', name: '兰州' },
      { pinyin: 'lasa', name: '拉萨' },
      { pinyin: 'ledonglizuzizhixian', name: '乐东黎族自治县' },
      { pinyin: 'leshan', name: '乐山' },
      { pinyin: 'liangjiangxinqu', name: '两江新区' },
      { pinyin: 'liangshanyizuzizhizhou', name: '凉山彝族自治州' },
      { pinyin: 'lianjiangxian', name: '连江县' },
      { pinyin: 'lianyungang', name: '连云港' },
      { pinyin: 'liaocheng', name: '聊城' },
      { pinyin: 'liaoyang', name: '辽阳' },
      { pinyin: 'liaoyuan', name: '辽源' },
      { pinyin: 'lijiang', name: '丽江' },
      { pinyin: 'lincang', name: '临沧' },
      { pinyin: 'linfen', name: '临汾' },
      { pinyin: 'lingaoxian', name: '临高县' },
      { pinyin: 'lingshuilizuzizhixian', name: '陵水黎族自治县' },
      { pinyin: 'linxiahuizuzizhizhou', name: '临夏回族自治州' },
      { pinyin: 'linyi', name: '临沂' },
      { pinyin: 'linzhidiqu', name: '林芝地区' },
      { pinyin: 'lishui', name: '丽水' },
      { pinyin: 'liupanshui', name: '六盘水' },
      { pinyin: 'liuzhou', name: '柳州' },
      { pinyin: 'longnan', name: '陇南' },
      { pinyin: 'longyan', name: '龙岩' },
      { pinyin: 'loudi', name: '娄底' },
      { pinyin: 'luan', name: '六安' },
      { pinyin: 'luhuandao', name: '路环岛' },
      { pinyin: 'luohe', name: '漯河' },
      { pinyin: 'luoyang', name: '洛阳' },
      { pinyin: 'luzhou', name: '泸州' },
      { pinyin: 'lvliang', name: '吕梁' },
    ],
  },
  {
    letter: 'm',
    city: [
      { pinyin: 'maanshan', name: '马鞍山' },
      { pinyin: 'maoming', name: '茂名' },
      { pinyin: 'meishan', name: '眉山' },
      { pinyin: 'meizhou', name: '梅州' },
      { pinyin: 'mianyang', name: '绵阳' },
      { pinyin: 'miaolixian', name: '苗栗县' },
      { pinyin: 'mudanjiang', name: '牡丹江' },
    ],
  },
  {
    letter: 'n',
    city: [
      { pinyin: 'nanchang', name: '南昌' },
      { pinyin: 'nanchong', name: '南充' },
      { pinyin: 'nanjing', name: '南京' },
      { pinyin: 'nanning', name: '南宁' },
      { pinyin: 'nanping', name: '南平' },
      { pinyin: 'nantong', name: '南通' },
      { pinyin: 'nantouxian', name: '南投县' },
      { pinyin: 'nanyang', name: '南阳' },
      { pinyin: 'naqudiqu', name: '那曲地区' },
      { pinyin: 'neijiang', name: '内江' },
      { pinyin: 'ningbo', name: '宁波' },
      { pinyin: 'ningde', name: '宁德' },
      { pinyin: 'nujianglisuzuzizhizhou', name: '怒江傈僳族自治州' },
    ],
  },
  {
    letter: 'p',
    city: [
      { pinyin: 'panjin', name: '盘锦' },
      { pinyin: 'panzhihua', name: '攀枝花' },
      { pinyin: 'penghuxian', name: '澎湖县' },
      { pinyin: 'pingdingshan', name: '平顶山' },
      { pinyin: 'pingdongxian', name: '屏东县' },
      { pinyin: 'pingliang', name: '平凉' },
      { pinyin: 'pingxiang', name: '萍乡' },
      { pinyin: 'puer', name: '普洱' },
      { pinyin: 'putian', name: '莆田' },
      { pinyin: 'puyang', name: '濮阳' },
    ],
  },
  {
    letter: 'q',
    city: [
      {
        pinyin: 'qiandongnanmiaozudongzuzizhizhou',
        name: '黔东南苗族侗族自治州',
      },
      { pinyin: 'qianjiang', name: '潜江' },
      { pinyin: 'qiannanbuyizumiaozuzizhizhou', name: '黔南布依族苗族自治州' },
      {
        pinyin: 'qianxinanbuyizumiaozuzizhizhou',
        name: '黔西南布依族苗族自治州',
      },
      { pinyin: 'qingdao', name: '青岛' },
      { pinyin: 'qingyang', name: '庆阳' },
      { pinyin: 'qingyuan', name: '清远' },
      { pinyin: 'qinhuangdao', name: '秦皇岛' },
      { pinyin: 'qinzhou', name: '钦州' },
      { pinyin: 'qionghai', name: '琼海' },
      { pinyin: 'qiongzhonglizumiaozuzizhixian', name: '琼中黎族苗族自治县' },
      { pinyin: 'qiqihaer', name: '齐齐哈尔' },
      { pinyin: 'qitaihe', name: '七台河' },
      { pinyin: 'quanzhou', name: '泉州' },
      { pinyin: 'qujing', name: '曲靖' },
      { pinyin: 'quzhou', name: '衢州' },
    ],
  },
  {
    letter: 'r',
    city: [
      { pinyin: 'rikaze', name: '日喀则' },
      { pinyin: 'rizhao', name: '日照' },
    ],
  },
  {
    letter: 's',
    city: [
      { pinyin: 'sanmenxia', name: '三门峡' },
      { pinyin: 'sanming', name: '三明' },
      { pinyin: 'sansha', name: '三沙' },
      { pinyin: 'sanya', name: '三亚' },
      { pinyin: 'shanghai', name: '上海' },
      { pinyin: 'shangluo', name: '商洛' },
      { pinyin: 'shangqiu', name: '商丘' },
      { pinyin: 'shangrao', name: '上饶' },
      { pinyin: 'shannandiqu', name: '山南地区' },
      { pinyin: 'shantou', name: '汕头' },
      { pinyin: 'shanwei', name: '汕尾' },
      { pinyin: 'shaoguan', name: '韶关' },
      { pinyin: 'shaoxing', name: '绍兴' },
      { pinyin: 'shaoyang', name: '邵阳' },
      { pinyin: 'shennongjialinqu', name: '神农架林区' },
      { pinyin: 'shenyang', name: '沈阳' },
      { pinyin: 'shenzhen', name: '深圳' },
      { pinyin: 'shihezi', name: '石河子' },
      { pinyin: 'shijiazhuang', name: '石家庄' },
      { pinyin: 'shiyan', name: '十堰' },
      { pinyin: 'shizuishan', name: '石嘴山' },
      { pinyin: 'shuanghe', name: '双河' },
      { pinyin: 'shuangyashan', name: '双鸭山' },
      { pinyin: 'shuozhou', name: '朔州' },
      { pinyin: 'siping', name: '四平' },
      { pinyin: 'songyuan', name: '松原' },
      { pinyin: 'suihua', name: '绥化' },
      { pinyin: 'suining', name: '遂宁' },
      { pinyin: 'suizhou', name: '随州' },
      { pinyin: 'suqian', name: '宿迁' },
      { pinyin: 'suzhou', name: '苏州' },
      { pinyin: 'suzhou', name: '宿州' },
    ],
  },
  {
    letter: 't',
    city: [
      { pinyin: 'tachengdiqu', name: '塔城地区' },
      { pinyin: 'taian', name: '泰安' },
      { pinyin: 'taibei', name: '台北' },
      { pinyin: 'taidongxian', name: '台东县' },
      { pinyin: 'tainan', name: '台南' },
      { pinyin: 'taiyuan', name: '太原' },
      { pinyin: 'taizhong', name: '台中' },
      { pinyin: 'taizhou', name: '泰州' },
      { pinyin: 'taizhou', name: '台州' },
      { pinyin: 'tangshan', name: '唐山' },
      { pinyin: 'taoyuanxian', name: '桃园县' },
      { pinyin: 'tianjin', name: '天津' },
      { pinyin: 'tianmen', name: '天门' },
      { pinyin: 'tianshui', name: '天水' },
      { pinyin: 'tieling', name: '铁岭' },
      { pinyin: 'tiemenguan', name: '铁门关' },
      { pinyin: 'tongchuan', name: '铜川' },
      { pinyin: 'tonghua', name: '通化' },
      { pinyin: 'tongliao', name: '通辽' },
      { pinyin: 'tongling', name: '铜陵' },
      { pinyin: 'tongren', name: '铜仁' },
      { pinyin: 'tulufandiqu', name: '吐鲁番地区' },
      { pinyin: 'tumushuke', name: '图木舒克' },
      { pinyin: 'tunchangxian', name: '屯昌县' },
    ],
  },
  {
    letter: 'w',
    city: [
      { pinyin: 'wanning', name: '万宁' },
      { pinyin: 'weifang', name: '潍坊' },
      { pinyin: 'weihai', name: '威海' },
      { pinyin: 'weinan', name: '渭南' },
      { pinyin: 'wenchang', name: '文昌' },
      { pinyin: 'wenshanzhuangzumiaozuzizhizhou', name: '文山壮族苗族自治州' },
      { pinyin: 'wenzhou', name: '温州' },
      { pinyin: 'wuhai', name: '乌海' },
      { pinyin: 'wuhan', name: '武汉' },
      { pinyin: 'wuhu', name: '芜湖' },
      { pinyin: 'wujiaqu', name: '五家渠' },
      { pinyin: 'wulanchabu', name: '乌兰察布' },
      { pinyin: 'wulumuqi', name: '乌鲁木齐' },
      { pinyin: 'wuwei', name: '武威' },
      { pinyin: 'wuxi', name: '无锡' },
      { pinyin: 'wuzhishan', name: '五指山' },
      { pinyin: 'wuzhong', name: '吴忠' },
      { pinyin: 'wuzhou', name: '梧州' },
    ],
  },
  {
    letter: 'x',
    city: [
      { pinyin: 'xiamen', name: '厦门' },
      { pinyin: 'xian', name: '西安' },
      { pinyin: 'xianggang', name: '香港' },
      { pinyin: 'xiangtan', name: '湘潭' },
      { pinyin: 'xiangxitujiazumiaozuzizhizhou', name: '湘西土家族苗族自治州' },
      { pinyin: 'xiangyang', name: '襄阳' },
      { pinyin: 'xianning', name: '咸宁' },
      { pinyin: 'xiantao', name: '仙桃' },
      { pinyin: 'xianyang', name: '咸阳' },
      { pinyin: 'xiaogan', name: '孝感' },
      { pinyin: 'xilinguoleimeng', name: '锡林郭勒盟' },
      { pinyin: 'xinbei', name: '新北' },
      { pinyin: 'xinganmeng', name: '兴安盟' },
      { pinyin: 'xingtai', name: '邢台' },
      { pinyin: 'xining', name: '西宁' },
      { pinyin: 'xinjie', name: '新界' },
      { pinyin: 'xinxiang', name: '新乡' },
      { pinyin: 'xinyang', name: '信阳' },
      { pinyin: 'xinyu', name: '新余' },
      { pinyin: 'xinzhou', name: '忻州' },
      { pinyin: 'xinzhu', name: '新竹' },
      { pinyin: 'xinzhuxian', name: '新竹县' },
      { pinyin: 'xishuangbannadaizuzizhizhou', name: '西双版纳傣族自治州' },
      { pinyin: 'xixianxinqu', name: '西咸新区' },
      { pinyin: 'xuancheng', name: '宣城' },
      { pinyin: 'xuchang', name: '许昌' },
      { pinyin: 'xuzhou', name: '徐州' },
    ],
  },
  {
    letter: 'y',
    city: [
      { pinyin: 'yaan', name: '雅安' },
      { pinyin: 'yanan', name: '延安' },
      { pinyin: 'yanbianchaoxianzuzizhizhou', name: '延边朝鲜族自治州' },
      { pinyin: 'yancheng', name: '盐城' },
      { pinyin: 'yangjiang', name: '阳江' },
      { pinyin: 'yangquan', name: '阳泉' },
      { pinyin: 'yangzhou', name: '扬州' },
      { pinyin: 'yantai', name: '烟台' },
      { pinyin: 'yibin', name: '宜宾' },
      { pinyin: 'yichang', name: '宜昌' },
      { pinyin: 'yichun', name: '伊春' },
      { pinyin: 'yichun', name: '宜春' },
      { pinyin: 'yilanxian', name: '宜兰县' },
      { pinyin: 'yilihasakezizhizhou', name: '伊犁哈萨克自治州' },
      { pinyin: 'yinchuan', name: '银川' },
      { pinyin: 'yingkou', name: '营口' },
      { pinyin: 'yingtan', name: '鹰潭' },
      { pinyin: 'yiyang', name: '益阳' },
      { pinyin: 'yongzhou', name: '永州' },
      { pinyin: 'yueyang', name: '岳阳' },
      { pinyin: 'yulin', name: '榆林' },
      { pinyin: 'yulin', name: '玉林' },
      { pinyin: 'yuncheng', name: '运城' },
      { pinyin: 'yunfu', name: '云浮' },
      { pinyin: 'yunlinxian', name: '云林县' },
      { pinyin: 'yushuzangzuzizhizhou', name: '玉树藏族自治州' },
      { pinyin: 'yuxi', name: '玉溪' },
    ],
  },
  {
    letter: 'z',
    city: [
      { pinyin: 'zaozhuang', name: '枣庄' },
      { pinyin: 'zhanghuaxian', name: '彰化县' },
      { pinyin: 'zhangjiajie', name: '张家界' },
      { pinyin: 'zhangjiakou', name: '张家口' },
      { pinyin: 'zhangye', name: '张掖' },
      { pinyin: 'zhangzhou', name: '漳州' },
      { pinyin: 'zhanjiang', name: '湛江' },
      { pinyin: 'zhaoqing', name: '肇庆' },
      { pinyin: 'zhaotong', name: '昭通' },
      { pinyin: 'zhengzhou', name: '郑州' },
      { pinyin: 'zhenjiang', name: '镇江' },
      { pinyin: 'zhongshan', name: '中山' },
      { pinyin: 'zhongwei', name: '中卫' },
      { pinyin: 'zhoukou', name: '周口' },
      { pinyin: 'zhoushan', name: '舟山' },
      { pinyin: 'zhoushanqundaoxinqu', name: '舟山群岛新区' },
      { pinyin: 'zhuhai', name: '珠海' },
      { pinyin: 'zhumadian', name: '驻马店' },
      { pinyin: 'zhuzhou', name: '株洲' },
      { pinyin: 'zibo', name: '淄博' },
      { pinyin: 'zigong', name: '自贡' },
      { pinyin: 'ziyang', name: '资阳' },
      { pinyin: 'zunyi', name: '遵义' },
    ],
  },
];
export const CITIES_LIST = CITIES_PINYIN_LIST.map((item) =>
  item.city.map((city) => city),
).flat();
